
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MemberCollection extends Vue {
  @Prop({ required: true }) private page!: number;

  @Prop({ required: true }) private pageSize!: number;

  @Prop({ required: true }) private totalCount!: number;

  @Prop({ required: true }) private data!: any[];

  private headers = [
    { text: '外部ID', value: 'userIdPublic', width: 120 },
    { text: '註冊時間', value: 'createdOn', width: 150 },
    { text: '會員類型', value: 'roles', width: 60 },
    { text: '姓名', value: 'fullName', width: 150 },
    { text: '帳號 / Email / 統編', value: 'account', width: 150 },
    { text: '手機', value: 'mobile' },
    { text: '基本驗證', value: 'basic', width: 60 },
    { text: '實名驗證', value: 'real' },
    { text: '明細', value: 'actions' },
  ];

  private get pageCount() {
    return Math.ceil((this.totalCount || 0) / (this.pageSize || 20));
  }

  private get collection() {
    return [...(this.data || [])];
  }

  @Emit()
  public updatePage(page: number): number {
    return page;
  }
}
